import {useTranslation} from "next-i18next";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import Image from "next/image";
import {useRouter} from "next/router";
import {useState} from "react";
import Button from "../components/common/Button";
import HeaderImageWithHeading from "../components/common/HeaderImageWithHeading";
import ContactForm, {ContactFormInterface} from "../components/ContactForm/ContactForm";
import {CustomTFunction, TranslationsKeys} from "../TranslationTypes";
import IconEmail from "../data/Icons/leon-inmobiliaria-icons-e-mail.svg";
import IconPhone from "../data/Icons/leon-inmobiliaria-icons-phone.svg";
import IconFax from "../data/Icons/leon-inmobiliaria-icons-fax.svg";
import Link from "next/link";
import {requestsCreationAttributes} from "../models/requests";
import {postRequest} from "../data/ReactQueries";
import ContactTypeEnums from "../enums/ContactTypeEnums";
import SpamFilterQuestion from "../components/common/SpamFilterQuestion";
import AgbChecklist from "../components/common/AgbChecklist";

export default function Page() {
	const {t} = useTranslation() as unknown as {
		t: CustomTFunction<TranslationsKeys>;
	};

	const router = useRouter();
	const [agbAccepted, setAgbAccepted] = useState(false);

	const [contactForm, setContactForm] = useState<ContactFormInterface>({
		customer_id: 0,
		email: "",
		firstname: "",
		lastname: "",
		title: "Herr"
	});


	const [requestCreateObject, setRequestCreateObject] =
		useState<requestsCreationAttributes | null>({
			object_id: "",
			from_date: "",
			to_date: "",
			persons: "",
			children: "",
			additional_information: "",
			email: "",
			babybuggys: 0,
			babychairs: 0,
			pets: "",
			bedding: 0,
			city: "",
			contact_type:
			ContactTypeEnums.kontakt /* (router.query.source as string) ?? "kontakt" */,
			created: 0,
			firstname: "",
			lastname: "",
			phone: "",
			customer_id: "",
			street: "",
			extrabeds: 0,
			fax: "",
			languagecode: router.locale ?? "",
			message: "",
			mobile: "",
			number: "",
			pets_amount: 0,
			postcode: "",
			read: 0,
			responded: 0,
			responded_from: "",
			title: "Herr",
			towels: 0
		});

	function handleSubmitContactForm(
		e: React.FormEvent<HTMLFormElement>,
		locale = "en"
	) {
		e.preventDefault();
		if (!requestCreateObject) return;
		postRequest(requestCreateObject, locale);
		router.push("/contact-success");
	}

	function updateRequestCreateObject(
		key: keyof requestsCreationAttributes,
		value: requestsCreationAttributes[keyof requestsCreationAttributes]
	) {
		setRequestCreateObject((prev) => {
			if (prev === null) {
				return {
					[key]: value
				} as requestsCreationAttributes;
			}
			return {
				...prev,
				[key]: value
			};
		});
	}


	const [spamFilterPassed, setSpamFilterPassed] = useState(false);
	return (
		<div className="flex flex-col gap-14">
			<HeaderImageWithHeading
				imageSrc="/images/leon-company-2.png"
				subtitle={t("pages.contact.subHeading")!}
				title={t("pages.contact.heading")!}
			/>

			<div
				id="contact"
				className="flex flex-col lg:flex-row items-center gap-10 lg:gap-2 lg:py-10 lg:mx-16 "
			>
				<div className="relative w-[500px] h-[500px] text-center flex-1">
					<Image
						quality={90}
						src="/images/leon-company-1.png"
						alt=""
						fill
						className="object-cover p-10"
					/>
				</div>
				<div className="flex-1 flex items-center justify-center sm:w-min">
					<div className="xl:px-28 flex flex-col gap-6 w-full sm:w-min px-4">
						<h3>{t("pages.contact.infopanel.title")}</h3>
						<div className="flex flex-row lg:items-start lg:gap-28 gap-x-16 justify-between sm:items-center flex-wrap gap-y-6 sm:gap-y-0 items-start sm:flex-nowrap">
							<div className="flex flex-col w-max">
								<p className="font-bold mb-4 whitespace-nowrap">
									{t("pages.contact.infopanel.address.title")}
								</p>
								<p className="whitespace-pre-wrap">
									{t("pages.contact.infopanel.addressfields", {
										joinArrays: "\n"
									})}
								</p>
							</div>
							<div className="flex flex-col [&>*]:whitespace-nowrap">
								<p className="font-bold mb-4 whitespace-nowrap">
									{t("pages.contact.infopanel.contact.title")}
								</p>
								<div className="flex flex-row items-center gap-2">
									<IconPhone className="w-5 h-5"/>
									<Link className="text-leo-orange" href={`tel:${t("consts.contact.tel").replaceAll(" ", "")}`}>
										{t("consts.contact.tel")}
									</Link>
								</div>
								<div className="flex flex-row gap-2 items-center">
									<IconFax className="w-5 h-5"/>
									<span>{t("consts.contact.fax")}</span>
								</div>
								<div className="flex items-center flex-row gap-2">
									<IconEmail className="w-5 h-5"/>
									<Link
										href={"mailto:info@leon-inmobiliaria.com"}
										className="text-leo-orange"
									>
										{t("consts.contact.email")}
									</Link>
								</div>
							</div>
						</div>
						<Button
							text={t("pages.contact.infopanel.button")}
							transparent={false}
							border={false}
							minWidth={"w-min"}
							height={"h-[40px]"}
							onClick={() => {
								window.open(
									"https://www.google.com/maps?ll=42.253994,3.111101&z=14&t=m&hl=de-DE&gl=US&mapclient=embed&cid=8395907912179263167",
									"_blank"
								);
							}}
							className="rounded-[10px]"
							padding={"px-6 py-[14px]"}
						/>
					</div>
				</div>
			</div>
			<hr className="h-px mx-auto bg-gray-200 border-0 dark:bg-gray-700 w-[60%]"/>
			<form
				id="contact-form"
				onSubmit={(e) => handleSubmitContactForm(e, router.locale)}
				className="flex flex-col gap-8 p-8 lg:p-16"
			>
				<h3>{t("pages.contact.form.title")}</h3>
				<ContactForm
					smallVersion
					onChange={(key, value) => {
						updateRequestCreateObject(key, value);
					}}
				/>
				<AgbChecklist onChange={setAgbAccepted}/>
				<SpamFilterQuestion onChange={setSpamFilterPassed}/>
				<div className="flex flex-row items-end gap-4 flex-wrap">
					<Button
						text={t("pages.contact.form.submit")}
						transparent={false}
						border={false}
						minWidth={"sm:w-min w-full"}
						disabled={
							!agbAccepted ||
							!spamFilterPassed
						}
						type="submit"
						height={"h-[40px]"}
						className="rounded-[10px]"
						padding={"px-6 py-[14px]"}
					/>
					<Button
						text={t("pages.contact.form.reset")}
						transparent={false}
						border={false}
						type="reset"
						minWidth={"sm:w-min w-full"}
						onClick={(e) => {
							setAgbAccepted(false);
							setContactForm({
								customer_id: 0,
								email: "",
								firstname: "",
								lastname: "",
								title: "Herr"
							});
						}}
						height={"h-[40px]"}
						className="rounded-[10px]"
						padding={"px-6 py-[14px]"}
					/>
				</div>
			</form>
		</div>
	);
}

export async function getStaticProps({locale}: any) {
	return {
		props: {
			...(await serverSideTranslations(locale, ["common"]))
		}
	};
}
